import { Box, Heading, Stack } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { ButtonLink } from "@src/components/ui-kit";
import { API_BASE_URL } from "@src/config/constants";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";

export const BmailBoxIntegration = observer(function BmailBoxIntegration() {
  const { settingsModalStore } = useStore();

  return (
    <Stack py="4" spacing="4">
      <Heading as="h3" py="2" textAlign="left" size="md">
        <Trans>Bmail box integration</Trans>
      </Heading>

      <Box>
        {settingsModalStore.bmailBoxIntegrationStore.isIntegrationActive ? (
          <ButtonLink
            href={`${API_BASE_URL}/bmail/disconnect-google`}
            isExternal
            onClick={settingsModalStore.modalState.onClose}
            colorScheme="red"
          >
            <Trans>Disconnect</Trans>
          </ButtonLink>
        ) : (
          <ButtonLink
            href={`${API_BASE_URL}/bmail/connect-google`}
            isExternal
            onClick={settingsModalStore.modalState.onClose}
          >
            <Trans>Connect</Trans>
          </ButtonLink>
        )}
      </Box>
    </Stack>
  );
});
